console.log('oplata.js loaded: ', Math.round(performance.now()));

document.addEventListener('DOMContentLoaded', function () {
    let method = location.hash.replace('#', '');

    if (method) {
        show_and_scroll_el(document.getElementById('desc-' + method), 200);
    }

    [].forEach.call(document.querySelectorAll('.paysystem'), function (el) {
        el.addEventListener('click', function () {
            if (document.getElementById('current_currency').value === 'RUB') {
                method = this.id;

                let page_y_offset = pageYOffset;

                location.hash = method;
                scrollTo(0, page_y_offset);

                [].forEach.call(document.querySelectorAll('.descpayment'), function (el_descpayment) {
                    el_descpayment.style.display = 'none';
                });

                show_and_scroll_el(document.getElementById('desc-' + method));
            } else {
                if (document.getElementById('current_site').value === 'world') {
                    location.href = '/pay';
                } else {
                    location.href = '/en/pay';
                }
            }
        });
    });

    function show_and_scroll_el(el, time) {
        if (!el) return;

        time = time || 0;
        el.style.display = 'block';

        setTimeout(function () {
            el.scrollIntoView();
            scrollBy(0, (viewport_width < 1185 ? -20 : -175));
        }, time);
    }
});